$(function () {
    // let card = $('.section-3-3');
    // console.log('131312312312312');
    $('.section-3-3 .tabs-container .tab-btn-container a').click(function (e) {
        e.preventDefault();

        const target = $(this).attr('data-target');
        $('.section-3-3 .tabs-container .tab-btn-container').removeClass('active');
        $(target).parents('.tabs-content-container').find('.content-container').removeClass('active');

        $(this).parents('.tab-btn-container').addClass('active');
        $(target).addClass('active');

        if (target === '#section-3-3-di-lahan-mineral') {
            $('.section-3-3').addClass('bg-gray');
        } else {
            $('.section-3-3').removeClass('bg-gray');
        }
    });
});